import { Dot } from 'src/components/ActionsMenu/styles';
import styled from 'styled-components';
import { components } from 'react-select';

export const VariationsContainer = styled.div`
  width: 200px;
`;

export const VariationsWrapper = styled.div`
  background: #fff;
  border-radius: 4px;
  padding: 8px;
  margin-top: 15px;
  margin-right: 5px;
  margin-left: 15px;
`;

export const VariationsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const VariationTitle = styled.h6`
  font-weight: 600;
  font-size: 14px;
  color: #000000;
  display: inline-block;
  margin: 0;
`;

export const ListStyled = styled.ul`
  padding: 0;
  list-style: none;
  margin-bottom: 0;
`;

export const ListItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0px 5px 14px;
  margin-bottom: 8px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  background: ${({ theme, active }) => (active ? theme.colors.action.hover : 'transparent')};
  ${Dot} {
    width: 3px;
    height: 3px;
    visibility: hidden;
  }

  :hover {
    background: ${({ theme }) => theme.colors.action.hover};
    ${Dot} {
      visibility: visible;
    }
  }
`;

export const IntentBlock = styled.div`
  width: 656px;
  & > h5 {
    color: ${props => props.theme.colors.gray6};
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  & > div {
    padding: 24px;
    background-color: ${props => props.theme.colors.background.default};
    border-radius: 4px;
    border: 1px solid #ddd;
    & > p {
      font-size: 14px;
      font-weight: 600;
    }
  }
`;

export const IntentFieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const IntentField = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  align-items: ${props => props.alignItems || 'center'};
  & > p {
    color: #000;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    margin: 0;
  }
  & > input {
    max-width: none;
  }
`;

export const CustomSelectOption = styled(components.Option)`
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  & > div {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    line-height: 16px;
    label {
      height: 16px;
      margin: 0;
    }
  }
  & > span:last-child {
    font-size: 13px;
    color: ${props => props.theme.colors.gray5};
  }
`;
